// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './NeuralGlassHomepage.css';

const Footer = () => {
  return (
    <footer>
      <div className='footer-content'>

        {/* Top: Logo + Socials */}
        <div className='footer-top'>
          <div className='footer-logo'>
            🎯 terview.ai
          </div>
          <div className='footer-socials'>
            <a href='https://linkedin.com/in/yourprofile' target='_blank' rel='noopener noreferrer' className='footer-social-btn'>in</a>
            <a href='https://github.com/yourprofile' target='_blank' rel='noopener noreferrer' className='footer-social-btn'>gh</a>
            <a href='https://twitter.com/yourprofile' target='_blank' rel='noopener noreferrer' className='footer-social-btn'>tw</a>
            <a href='mailto:your.email@example.com' className='footer-social-btn'>✉</a>
          </div>
        </div>

        <hr className='footer-divider' />

        {/* 4-Column Grid */}
        <div className='footer-columns'>

          <div className='footer-column'>
            <h4 className='footer-col-title'>PRODUCTS</h4>
            <Link to='/InterviewAssistant' className='footer-col-link'>Interview Assistant</Link>
            <Link to='/mockInterview' className='footer-col-link'>Mock AI Interview</Link>
            <Link to='/BuildResume' className='footer-col-link'>Resume Builder</Link>
            <Link to='/CoverLetter' className='footer-col-link'>Cover Letter</Link>
            <Link to='/ATSCheck' className='footer-col-link'>ATS Check</Link>
            <Link to='/InterviewQuestions' className='footer-col-link'>Interview Questions</Link>
            <Link to='/LinkedInOptimizer' className='footer-col-link'>LinkedIn Optimizer</Link>
            <Link to='/certification' className='footer-col-link'>AI Certification</Link>
            <Link to='/portfolio' className='footer-col-link'>Portfolio Builder</Link>
          </div>

          <div className='footer-column'>
            <h4 className='footer-col-title'>DOWNLOADS</h4>
            <a href='/downloads/TERVIEW-1.0.0-mac.dmg' className='footer-col-link'>Mac App (.dmg)</a>
            <a href='/downloads/TERVIEW Setup 1.0.0.exe' className='footer-col-link'>Windows App (.exe)</a>
          </div>

          <div className='footer-column'>
            <h4 className='footer-col-title'>RESOURCES</h4>
            <a href='#features' className='footer-col-link'>Features</a>
            <a href='#contact' className='footer-col-link'>Contact Us</a>
            <a href='#' className='footer-col-link'>Documentation</a>
            <a href='#' className='footer-col-link'>FAQ</a>
            <a href='#' className='footer-col-link'>Testimonials</a>
          </div>

          <div className='footer-column'>
            <h4 className='footer-col-title'>COMPANY</h4>
            <a href='/about' className='footer-col-link'>About</a>
            <a href='/privacy-policy' className='footer-col-link'>Privacy Policy</a>
            <a href='/terms-of-service' className='footer-col-link'>Terms of Service</a>
            <a href='#contact' className='footer-col-link'>Support</a>
            <a href='#' className='footer-col-link'>Pricing</a>
          </div>

        </div>

        <hr className='footer-divider' />

        {/* Bottom */}
        <div className='footer-bottom'>
          <p className='footer-copyright'>© 2025 terview.ai. All rights reserved.</p>
          <p className='footer-design'>
            Made by <a href='#' className='footer-credit-link'>Terview Technologies Pvt Ltd</a>
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;